import type { FundsTable_table$key } from '@generated/FundsTable_table.graphql';

export interface FundsTablePropsType {
    table: FundsTable_table$key;
    locationState: any;
    salesAdmission: string;
    downloadOverview: any;
    location?: any;
    currentLanguage: string;
}

export interface SortObjectType {
    col: string;
    order: SortOrder;
}

export const enum SortOrder {
    ASC = -1,
    DESC = 1,
}
